import axios from "axios";

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

export const downloadJobWorkIssueDetailsReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const from = cleanParam(inputs.from);
  const to = cleanParam(inputs.to);
  const year = cleanParam(inputs.year);
  const month = cleanParam(inputs.month);
  const factoryId = cleanParam(inputs.factory_id);
  const factoryName = cleanParam(
    inputs.factory_name || inputs.order_item_factory_name
  );

  if (from) urlParams.set("from", from);
  if (to) urlParams.set("to", to);
  if (year) urlParams.set("year", year);
  if (month) urlParams.set("month", month);
  if (factoryId) urlParams.set("factory_id", factoryId);
  if (factoryName) urlParams.set("factory_name", factoryName);

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/list-job-work-issue-details-report-excel${
        query ? `?${query}` : ""
      }`,
      config
    );
    const result = data?.data?.result;
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return result.trim();
    }
    return null;
  } catch (error) {
    console.log(error);
    if (error?.response?.data?.message) {
      throw error;
    }
    return null;
  }
};
